import { render, staticRenderFns } from "./economics.vue?vue&type=template&id=b32b5a30&scoped=true&"
import script from "./economics.vue?vue&type=script&lang=js&"
export * from "./economics.vue?vue&type=script&lang=js&"
import style0 from "./economics.vue?vue&type=style&index=0&id=b32b5a30&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b32b5a30",
  null
  
)

export default component.exports